export default __webpack_public_path__ + "static/media/640_dummy2016-modelportfolio01-de-mobile.e386e271.png";